export const CUBE_FILTERS = {
  PORTFOLIOS_ID: 'Portfolios.id',
  PORTFOLIOS_YEAR: 'Portfolios.year',
  USERS_ID: 'Users.id',
  INDICATORS_NAME: 'Indicators.name'
};

export default CUBE_FILTERS;
